// extracted by mini-css-extract-plugin
export default {"formatBar":"FormatBar_formatBar__gs0m5","active":"FormatBar_active__yrqT+","colorPicker":"FormatBar_colorPicker__Tiqtr"};